// Window events between Cinch AI and the rest of the app, in a module with no imports so neither side
// pulls in the other (the customer drawer's provider sits inside the Cinch AI provider).

// CINCHAI-142: Cinch AI's open_customer action, as `detail`; the customer drawer's provider opens it.
export const OPEN_CUSTOMER_EVENT = 'cinch-ai:open-customer';